import { useState } from 'react';
import { ImportModal } from '@/components/import/ImportModal';

export function Header() {
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const handleImportComplete = () => {
    // Refresh the page to show new data
    window.location.reload();
  };

  return (
    <header className="header text-center mb-8 pb-5 border-b border-border">
      <div className="flex items-center justify-between mb-2">
        <div className="flex-1" />
        <h1 className="text-2xl font-bold">Twitter 数据浏览器</h1>
        <div className="flex-1 flex justify-end">
          <button
            onClick={() => setIsImportModalOpen(true)}
            className="px-4 py-2 bg-accent text-white rounded hover:bg-accent/90 transition text-sm"
          >
            Import Data
          </button>
        </div>
      </div>
      <p className="subtitle text-text-secondary text-sm">浏览你的点赞和收藏</p>
      <ImportModal
        isOpen={isImportModalOpen}
        onClose={() => setIsImportModalOpen(false)}
        onImportComplete={handleImportComplete}
      />
    </header>
  );
}
